<template>
    <div v-if="model && form && paciente">
        <rkm-area
            title="Paciente"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}
                                <b v-if="paciente.nomeSocial"
                                    >({{ paciente.nomeSocial }})</b
                                >
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p><b>Prontuário: </b>{{ paciente.prontuario }}</p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <b>CPF: </b>
                            <template v-if="paciente.cpf">
                                {{ paciente.cpf | formatCpf }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>

                        <rkm-col cols="3">
                            <b>CNS: </b>
                            <template v-if="paciente.cns">
                                {{ paciente.cns | formatCns }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>

                        <rkm-col cols="3">
                            <b>RG: </b>
                            <template v-if="paciente.rg">
                                {{ paciente.rg }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>

                        <rkm-col cols="3">
                            <b>Data de nascimento: </b>
                            <template v-if="paciente.dataNascimento">
                                {{ paciente.dataNascimento | formatDate }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>

                        <rkm-col cols="3">
                            <b>Idade: </b>
                            <template v-if="paciente.idade">
                                {{ paciente.idade.anos }} anos,
                                {{ paciente.idade.meses }} meses,
                                {{ paciente.idade.dias }} dias
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>

                        <rkm-col cols="3">
                            <b>Sexo: </b>
                            <template v-if="paciente.sexo">
                                {{ paciente.sexo.descricao }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>

                        <rkm-col cols="3">
                            <b>Classificação: </b>
                            <template v-if="paciente.classificacao">
                                {{ paciente.classificacao }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <p>
                                <b>Telefones: </b>
                                <template v-if="paciente.telefones">
                                    {{ paciente.telefones }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <b>Responsável cadastro: </b>
                            <template v-if="paciente.responsavelCadastro">
                                {{ paciente.responsavelCadastro }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>

                        <rkm-col>
                            <b>Unidade: </b>
                            <template v-if="paciente.unidadeReferencia">
                                {{ paciente.unidadeReferencia }}
                            </template>
                            <template v-else>
                                <i>Não informado</i>
                            </template>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Endereço" type="fieldset" v-if="paciente">
            <rkm-row>
                <rkm-col>
                    <b>Endereço: </b>
                    <template v-if="paciente.endereco">
                        {{ paciente.endereco.completo }}
                    </template>
                    <template v-else>
                        <i>Não informado</i>
                    </template>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-tabs v-model="tabIndex">

            <rkm-tab
                title="BUSCAR PRÉ-AGENDAMENTO"
                @click.prevent="changeTab(0)"
            >
                <tab-busca-agendamento
                    ref="Busca"
                    :form="form"
                    :model="model"
                    :jornada="form.agendarTransporteJornada"
                    :agendamentos="agendamentos"
                    :id="id"
                    @remove="remove"
                    @removeSelected="removeSelected"
                />
            </rkm-tab>

            <rkm-tab
                title="CADASTRAR PRÉ-AGENDAMENTO"
                @click.prevent="changeTab(1)"
            >
                <tab-cadastro-agendamento
                    ref="Cadastro"
                    :form="form"
                    :model="model"
                    :agendamentos="agendamentos"
                    :agendados="agendados"
                    :paciente="paciente"
                    @add="add"
                />
            </rkm-tab>
        </rkm-tabs>
    </div>
</template>

<script>
import { error, repository, stringCase, object } from "@/mixins";
import { mapActions } from "vuex";
import TabCadastroAgendamento from '@/components/transporte-paciente/pre-agendamento-transporte/components/cadastro/Form'
import TabBuscaAgendamento from '@/components/transporte-paciente/pre-agendamento-transporte/components/buscar/List'
import format from '@/filters/formats'

export default {
    components: {
        TabCadastroAgendamento,
        TabBuscaAgendamento
    },
    created() {
        this.repositories = {
            preAgendamentoTransporte: this.getConectaSusRepository("transportePaciente.preAgendamentoTransporte"),
            motivo: this.getConectaSusRepository("transportePaciente.motivo"),
        };
        this.load();
    },
    data: () => ({
        additionals: null,
        tabIndex: 0,
        form: null,
        model: null,
        paciente: null,
        agendamentos: null,
        agendados: null,
        destinos: [],
        pontos: [],
        veiculos: [],
        jornadas: [],
        localForm: {
            autocompleteFields: {
                motivo: [
                    {
                        key: "descricao",
                        searchable: true,
                    }
                ],
                municipio: [
                    {
                        key: "nome",
                        searchable: true
                    }
                ],
            }
        }
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading();
            this.repositories.preAgendamentoTransporte
                .edit(this.id)
                .then(({ data }) => {
                    this.additionals = data.additionals

                    this.setData(
                        data.form,
                        data.model,
                        data.paciente,
                        data.agendamentos,
                        data.agendados
                    )

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        setData(form, model, paciente, agendamentos, agendados) {
            if (form) {
                this.form = Object.assign(form);
            }
            if (model) {
                this.model = Object.assign(model);
            }
            if (paciente) {
                this.paciente = Object.assign(paciente);
            }
            if (agendamentos) {
                this.agendamentos = Object.assign(agendamentos);
            }
            if(agendados) {
                this.agendados = Object.assign(agendados);
            }
        },
        save() {
            if(this.tabIndex == 0) {
                this.$refs.Busca.save()
            }
            if(this.tabIndex == 1) {
                this.$refs.Cadastro.adicionarAgendamentos()
            }
        },
        add() {
            this.$emit('add')
        },
        remove(id) {
            this.agendamentos = this.agendamentos.filter(ag => ag.id != id)
        },
        removeSelected(selected) {
            this.agendamentos = this.agendamentos.filter(ag => !selected.includes(ag.id))
        },
        changeTab(index) {
            if(index == 0) {
                this.tabIndex = 0
            }
            if(index == 1) {
                this.tabIndex = 1
            }
        },
    },
    mixins: [error, repository, stringCase, object],
    props: {
        id: { type: [Number], default: null }
    }
};
</script>

<style scoped>
p {
    margin: 0px;
}
</style>
